import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';

import {
  DevicesStore,
  GatewayDevice,
  GatewayStore,
  InstallationFeaturesStore,
  RichDevice,
} from '@store';
import { Observable, Subject, take, takeUntil } from 'rxjs';
import { DEVICES_TO_COMMISSIONING_FOR_SYSTEM_OVERLAY } from 'src/app/+installations/single-room-control/src-overlay/commissioning/commissioning.model';
import { CommissioningService } from 'src/app/+installations/single-room-control/src-overlay/commissioning/commissioning.service';

@Component({
  selector: 'app-system-overlay',
  templateUrl: './system-overlay.component.html',
  styleUrls: ['./system-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SystemOverlayComponent implements OnInit, OnDestroy {
  constructor(
    public devicesStore: DevicesStore,
    public installationFeaturesStore: InstallationFeaturesStore,
    public gatewayStore: GatewayStore,
    private commissioningService: CommissioningService
  ) {}

  devicesOfV2Cascade: RichDevice[];
  isVicareThermostatMode$: Observable<boolean>;
  private ngUnsubscribe$: Subject<void> = new Subject();

  ngOnInit(): void {
    this.devicesStore.devicesOfV2Cascade$
      .pipe(take(1), takeUntil(this.ngUnsubscribe$))
      .subscribe((devicesOfV2Cascade) => {
        this.devicesOfV2Cascade = devicesOfV2Cascade;
      });

    this.isVicareThermostatMode$ = this.installationFeaturesStore.isVicareThermostatMode();
  }

  onAddDevice(): void {
    this.commissioningService.devicesToCommissioning$.next(
      DEVICES_TO_COMMISSIONING_FOR_SYSTEM_OVERLAY
    );
    this.commissioningService.openAddDeviceDialog();
  }

  deleteVitotrol(event: GatewayDevice): void {
    if (event) {
      this.commissioningService.deleteDevice(event);
    }
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
